import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledSection = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 clamp(28px, 6vw, 80px) 150px;

  .wrap {
    padding: 48px 34px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.38);
    border: 1px solid rgba(255, 255, 255, 0.52);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    box-shadow:
      0 14px 38px rgba(0, 0, 0, 0.045),
      inset 0 1px 0 rgba(255, 255, 255, 0.38);
    text-align: center;
  }

  .eyebrow {
    margin: 0 0 12px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 13px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .title {
    margin: 0 0 18px;
    color: var(--text-primary);
    font-size: clamp(36px, 4.8vw, 62px);
    line-height: 1.06;
    letter-spacing: -0.05em;
  }

  .copy {
    max-width: 760px;
    margin: 0 auto;
    color: var(--text-secondary);
    font-size: 17px;
    line-height: 1.85;
  }

  .row {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 30px;
  }

  .primaryBtn,
  .secondaryBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    padding: 0 24px;
    border-radius: 999px;
    text-decoration: none;
    font-size: 13px;
    font-family: var(--font-mono);
    transition: var(--transition);
  }

  .primaryBtn {
    color: #ffffff;
    background: #111111;
    border: 1px solid #111111;
  }

  .primaryBtn:hover {
    background: #2a2a2a;
    border-color: #2a2a2a;
    color: #ffffff;
  }

  .secondaryBtn {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.58);
    border: 1px solid var(--border-light);
  }

  .secondaryBtn:hover {
    color: var(--text-primary);
    border-color: var(--border-medium);
    background: rgba(255, 255, 255, 0.78);
  }
`;

const CTA = () => {
  return (
    <StyledSection>
      <div className="wrap">
        <p className="eyebrow">Let’s Build</p>
        <h2 className="title">Open to meaningful software, data, and AI work.</h2>
        <p className="copy">
          I’m interested in opportunities where I can design reliable systems,
          build analytical depth, and turn complexity into measurable outcomes.
        </p>

        <div className="row">
          <Link className="primaryBtn" to="/contact">
            Get in touch
          </Link>
          <Link className="secondaryBtn" to="/about">
            Read more
          </Link>
        </div>
      </div>
    </StyledSection>
  );
};

export default CTA;